import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'New product',
  tabs: {
    [Tab.General]: 'General',
    [Tab.NutritionInfo]: 'Nutrition info',
  },
  form: {
    categories: {
      label: 'Categories',
    },
    printer: {
      label: 'Printer',
    },
    name: {
      label: 'Name',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Description',
      placeholder: '180g beef paddy, salat, tomatos, cucumbers, jalapenos and yuppi sauce',
    },
    external_id: {
      label: '{{integration}} ref',
      placeholder: 'e.g. HubRise SKU reference',
      read_only_hint: 'Editable only while a HubRise integration is connected and menu sync is turned off.',
    },
    price: {
      label: 'Base price',
    },
    has_smart_pricing: {
      label: 'Special prices for pickup and delivery',
    },
    pickup_price: {
      label: 'Pickup price',
      placeholder: 'Not specified',
    },
    delivery_price: {
      label: 'Delivery price',
      placeholder: 'Not specified',
    },
    image: {
      label: 'Image (optional)',
    },
    has_combo_tax: {
      label: 'Has combo tax',
    },
    is_available: {
      label: 'In stock',
      subtitle: 'Showing on menu',
    },
    is_visible: {
      label: 'Visible',
      title: 'Visible on menu',
      subtitle_on: 'Customers can see this item',
      subtitle_off: 'Hidden from all customers',
    },
    is_available_for_pickup: {
      label: 'Available for pickup',
      subtitle_on: 'Customers can order for pickup',
      subtitle_off: 'Hidden from pickup menu',
    },
    is_available_for_delivery: {
      label: 'Available for delivery',
      subtitle_on: 'Customers can order for delivery',
      subtitle_off: 'Hidden from delivery menu',
    },
    modifiers: {
      label: 'Modifiers',
    },
  },
  labels: {
    smart_pricing_update_warning: 'By updating, all existing smart pricing rules for this product will be rewritten.',
    smart_pricing_remove_warning: 'After saving, all existing smart pricing rules for this product will be removed.',
  },
  availability: {
    title: 'Availability',
    helper:
      'Visibility is the master switch. Turn off a channel to hide this item from pickup or delivery customers without removing it from the menu.',
    status: {
      both: 'Both channels',
      pickup_only: 'Pickup only',
      delivery_only: 'Delivery only',
      hidden: 'Hidden',
      no_channels: 'No channels',
    },
    warning: {
      no_channels: "This item is visible but available on no channels — customers won't be able to order it.",
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Pickup only',
      delivery_only: 'Delivery only',
      no_channels: 'No channels',
    },
  },
  buttons: {
    save: 'Save',
    close: 'Close',
  },
  toasts: {
    changes_got_saved: 'Changes have been successfully saved!',
  },
};
